import { styled } from "utils";

const CarouselDot = styled("button", {
  height: 8,
  width: 8,
  borderRadius: "$circle",
  border: "none",
  padding: 0,
  backgroundColor: "$grey100",
  variants: { selected: { true: { backgroundColor: "$iris" } } },
});

export { CarouselDot };
